import React, { Component } from 'react';
import { Layout, message } from 'antd';
import Animate from 'rc-animate';
import GlobalHeader from 'components/GlobalHeader';
import TopNavHeader from 'components/TopNavHeader';
import styles from './Header.module.less';

const { Header } = Layout;

class HeaderView extends Component {
  state = {
    visible: true,
  };

  static getDerivedStateFromProps(props, state) {
    if (!props.autoHideHeader && !state.visible) {
      return {
        visible: true,
      };
    }
    return null;
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handScroll, { passive: true });
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handScroll);
  }

  handleNoticeClear = type => {
    message.success('success');
    const { dispatch } = this.props;
    dispatch({
      type: 'global/clearNotices',
      payload: type,
    });
  };

  render() {
    const { isMobile } = this.props;
    const { visible } = this.state;
    const HeaderDom = visible ? (
      <Header
        style={{ padding: 0, width: '100%', zIndex: 2 }}
        className={'' ? styles.fixedHeader : ''}
      >
        {isMobile ? (
          <TopNavHeader
            mode="horizontal"
            onNoticeClear={this.handleNoticeClear}
            onMenuClick={this.handleMenuClick}
            onNoticeVisibleChange={this.handleNoticeVisibleChange}
            {...this.props}
          />
        ) : (
          <GlobalHeader {...this.props} />
        )}
      </Header>
    ) : null;
    return (
      <Animate component="" transitionName="fade">
        {HeaderDom}
      </Animate>
    );
  }
}

export default HeaderView;
